exports.addParams = (params) => {
    if (!params) {
        params = {};
    }

    let newParams = {
        myTime:new Date().getTime(),
        myKey:window.sessionStorage.getItem('token')
    };
    return {...newParams, ...params};
}

exports.formatDateToYmd = (date, needTime) => {
    const targetDate = date || new Date();
    const year = targetDate.getFullYear();
    const month = String(targetDate.getMonth() + 1).padStart(2, '0');
    const day = String(targetDate.getDate()).padStart(2, '0');
    const hours = String(targetDate.getHours()).padStart(2, '0');
    const minutes = String(targetDate.getMinutes()).padStart(2, '0');
    const seconds = String(targetDate.getSeconds()).padStart(2, '0');

    if (needTime) {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
        return `${year}-${month}-${day}`;
    }
}